import React, { Component } from 'react'
import { connect } from 'react-redux'

export function mapStateToProps(state) {
    return {
        favourites: state.getIn(['ui', 'entityStack', 'favourites', 'entities']),
        entityStackVisible: state.getIn(['ui', 'entityStack', 'visibleEntityStack']),
    }
}

export default function (InnerComponent) {
    @connect(mapStateToProps, null)
    class HocConnect extends Component {
        render() {
            return <InnerComponent {...this.props} />
        }
    }
    return HocConnect
}
